import { defineEvent } from '../types/event';
export var PACK_MODE_SINGLES_SELECT = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'pack_mode_selected_singles'
        }
    ]
});
